import { ReactNode } from 'react';

import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--bui-space-2)',
  },
  label: {
    flex: 1,
  },
  value: {
    fontVariantNumeric: 'tabular-nums',
  },
});

type StatRowProps = {
  icon: ReactNode;
  label: string;
  value: ReactNode;
};

export const StatRow = ({ icon, label, value }: StatRowProps) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {icon}
      <Typography
        color="textSecondary"
        className={classes.label}
        variant="body2"
      >
        {label}
      </Typography>
      <Typography className={classes.value} component="span" variant="body2">
        {value}
      </Typography>
    </div>
  );
};
